import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

export default function AdminGuard({ children }) {
  const [status, setStatus] = useState('checking'); // 'checking' | 'authorized' | 'unauthorized'

  useEffect(() => {
    const token = sessionStorage.getItem('wp_token');
    if (!token) {
      setStatus('unauthorized');
      return;
    }

    fetch('/api/publishing/me', {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => {
        if (!res.ok) throw new Error('Not authorized');
        return res.json();
      })
      .then(data => {
        const roles = Array.isArray(data.roles) ? data.roles : [];
        const isAdmin = roles.includes('admin') || data.role === 'admin';
        const isActive = data.status === 'active';
        if (isAdmin && isActive) {
          setStatus('authorized');
        } else {
          setStatus('unauthorized');
        }
      })
      .catch(() => setStatus('unauthorized'));
  }, []);

  if (status === 'checking') {
    return (
      <div className="wp-portal__content">
        <p className="wp-portal__page-sub">Verifying access...</p>
      </div>
    );
  }

  if (status === 'unauthorized') {
    return <Navigate to="/auth/access-required" replace />;
  }

  return children;
}
